import { Currency } from 'models/Currency';

export const currencies = [
  { code: Currency.EUR, symbol: '€', text: 'Euro' },
  { code: Currency.USD, symbol: '$', text: 'USD' },
  { code: Currency.GBP, symbol: '£', text: 'GBP' },
  { code: Currency.DKK, symbol: 'kr', text: 'DKK' },
  { code: Currency.SEK, symbol: 'kr', text: 'SEK' },
  { code: Currency.NOK, symbol: 'kr', text: 'NOK' },
  { code: Currency.JPY, symbol: '¥', text: 'JPY' },
  { code: Currency.KRW, symbol: '₩', text: 'KRW' },
  { code: Currency.AUD, symbol: '$', text: 'AUD' },
  { code: Currency.CAD, symbol: '$', text: 'CAD' },
];
